import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearBatch, updateCompleted } from "state/reducers/pushBatching";
import MarketingNavigation from "../utils/components/MarketingNavigation";
import PushMarketingStepper from "../utils/components/push/PushMarketingStepper";
import MarketingToolTip from "../utils/components/MarketingToolTip";
import MarketingContainer from "../utils/components/MarketingContainer";
import "../utils/styles/marketing-dashboard.css";
import "react-phone-input-2/lib/style.css";

const PushResults = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const handleNextStep = () => {
    dispatch(clearBatch());
    history.push("/marketing");
  };
  useEffect(() => {
    dispatch(updateCompleted(true));
  }, []);
  return (

      <MarketingContainer>
        <MarketingNavigation />
        <PushMarketingStepper />
        <div className="flex flex-col my-auto justify-center px-3 mx-auto rounded-lg">
          <p className="text-6xl text-center mb-3 animate__animated animate__bounce animate__delay-1s">
            Success!
          </p>
          <div className="mx-auto pb-16">
            <button
              type="button"
              className="btn text-sm bg-green-500 ml-2 border-none"
              onClick={() => handleNextStep()}
            >
              Back to dashboard
            </button>
          </div>
        </div>
        <MarketingToolTip />
      </MarketingContainer>

  );
};

export default PushResults;
